export enum SignpostReferenceEnum {
  ONLY_TEXT = "ONLY_TEXT",
  ONLY_IMAGES = "ONLY_IMAGES",
  TEXT_IMAGES = "TEXT_IMAGES",
}
